import { Record, Map, List } from 'immutable'
import { updateSortCode, updateBalanceAndCurrency } from './account-utils'
import { updateDate } from './date-utils'

const Account = Record({
  accountId: 'ACCOUNT ID IS MISSING',
  accountIdentification: Map(),
  availableBalance: '',
  balanceAt: '',
  currency: '',
  currentBalance: '',
  expectedBalance: '',
  balances: List(),
  overdraftLimit: '',
  overdraftRemaining: '',
  pendingTransactions: '',
  customerRelationshipCode: '',
  description: '',
  nameUnavailable: true,
  name: 'Account Name Unavailable',
  shortName: 'Account Short Name Unavailable',
  isClosed: false,
  accountType: null,
  type: '',
  totalFixedDeposits: 0,
  parentAccountIdentification: null,
})

const buildDefaultAccountForId = accountId => new Account({ accountId })

const toRecord = account => {
  const acct = account.toObject()
  acct.nameUnavailable = !acct.name
  return new Account(acct)
}

function parseAccounts(customerAccounts = List()) {
  return customerAccounts
    .map(updateBalanceAndCurrency)
    .map(account =>
      account.has('accountIdentification')
        ? updateSortCode(['accountIdentification', 'bban', 'sortCode'])(account)
        : account
    )
    .map(updateSortCode(['parentAccountIdentification', 'bban', 'sortCode']))
    .map(updateDate(['balanceAt']))
    .update(sortAccounts)
    .map(toRecord)
}

function sortAccounts(accounts) {
  return accounts
    .sortBy(
      a =>
        a.getIn(['accountIdentification', 'iban']) ||
        a.getIn(['accountIdentification', 'bban', 'accountNumber']) ||
        a.getIn(['accountIdentification', 'pan', 'maskedPAN'])
    )
    .sortBy(a => a.get('name'))
}

export { Account, parseAccounts, buildDefaultAccountForId, toRecord }
